export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20curated%20fashion%20accessories%20including%20leather%20bag%20watch%20sunglasses%20and%20textile%20samples%20on%20warm%20terracotta%20and%20cream%20textured%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20minimalist%20photography%20with%20elegant%20organic%20composition%20and%20natural%20dried%20botanicals&width=1800&height=900&seq=hero-bg-fresh-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet curated product collection displayed on minimal workspace"
          title="Vigorbuy Spreadsheet 2026 — Curated Product Collection"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-6xl lg:text-7xl text-white leading-tight mb-6">
          The Largest Updated<br />
          <span className="text-accent-300">Vigorbuy Spreadsheet</span> in 2026
        </h1>
        <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the latest <strong>Vigorbuy Spreadsheet</strong>, trusted finds, QC guides,
          shipping tutorials, and buying resources updated daily.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            VigorBuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="#categories"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm border border-white/25 hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Finds
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {['Updated Daily', 'Verified Finds', 'Safety Guides', 'QC Tutorials', 'Shipping Resources'].map((item) => (
            <span key={item} className="flex items-center gap-1.5 text-white/70 text-xs md:text-sm whitespace-nowrap">
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}